export default __webpack_public_path__ + "static/stickiness-light-22c4f87e1ac64e6a7a40eef802fbd035.png";